import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pending-loan',
  templateUrl: './pending-loan.component.html',
  styleUrls: ['./pending-loan.component.sass']
})
export class PendingLoanComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
